import { FileCategory } from '@/types/fileCategory';
import type FileInfo from '@/types/fileInfo';
import { FileInfoType } from '@/types/fileInfoType';

type Params = {
  /** file_info 데이터 */
  file_info?: FileInfoType;
  /* 해당 데이터의 idx (예 - 게시물idx 등)*/
  idx?: string | number;
  /* 파일 카테고리 */
  fileCategory: FileCategory;
  noImgUrl?: string;
  isFile?: boolean;
};

export type ResolvedFileInfo = Partial<FileInfo> &
  Pick<FileInfo, 'file_html_full_path' | 'file_storage_path'>;

/** 이미지 소비자가 어느 경로를 사용해도 빈 src가 되지 않도록 표시 경로를 정규화 */
export default function getFileInfo({
  file_info,
  idx,
  fileCategory,
  noImgUrl,
  isFile = false,
}: Params): ResolvedFileInfo | null {
  const fallbackPath = noImgUrl ?? '/images/apps/common/no_img.svg';
  const noImgFileInfo: ResolvedFileInfo = {
    file_html_full_path: fallbackPath,
    file_storage_path: fallbackPath,
  };

  if (!idx) {
    return noImgFileInfo;
  }
  const fileInfos = file_info?.[fileCategory]?.[idx] as FileInfo[];

  if (!fileInfos?.length) {
    if (isFile) {
      return null;
    }
    return noImgFileInfo;
  }

  const fileInfo = fileInfos[0];
  const storagePath =
    fileInfo.file_storage_path || fileInfo.file_html_full_path || fallbackPath;
  const htmlPath =
    fileInfo.file_html_full_path || fileInfo.file_storage_path || fallbackPath;

  return {
    ...fileInfo,
    file_storage_path: storagePath,
    file_html_full_path: htmlPath,
  };
}
